<script lang="ts">
	import { t } from "@hitit/hub/src/stores";
	import type { RewardMinDTO } from "@hitit/api/src/types";
	import { RewardStatus } from "@hitit/api";
	import moment from "moment";

	export let list: RewardMinDTO[] = [];

	const addMinusSignStatus = [RewardStatus.USED];
	const cancelColorStatus = [
		RewardStatus.CANCELLEDBYADMIN,
		RewardStatus.CANCELLEDBYSTORE,
		RewardStatus.CANCELLEDBYUSER,
		RewardStatus.EXPIRED,
		RewardStatus.ORDERCANCELLED,
		RewardStatus.CANCELLED,
	];

	function addSignByStatus(status: RewardStatus, message: string | number) {
		if (typeof message == "number") {
			message = String(message);
			return Number(message) < 0 ? message : "+" + message;
		}

		const sign = addMinusSignStatus.indexOf(status) >= 0 ? "-" : "+";
		return `${sign} ${message}`;
	}

	function makePointStatusColumnClass(status: RewardStatus) {
		return cancelColorStatus.indexOf(status) >= 0;
	}
	function processingDate(time: string) {
		if (!time) return "";
		return !time
			? ""
			: moment(new Date(time + "Z").toISOString()).format("yyyy.MM.DD HH:mm");
	}

</script>

<div class="container">
	<div class="header">
		<div class="type col">{$t('global.point.pointColumn.type')}</div>
		<div class="phone col">{$t('global.point.pointColumn.phone')}</div>
		<div class="items col">{$t('global.point.pointColumn.orders')}</div>
		<div class="amount col">{$t('global.point.pointColumn.amount')}</div>
		<div class="createdate col">{$t('global.point.pointColumn.date')}</div>
	</div>
	<div class="body">
		{#each list as row}
			<div class="row">
				<div
					class="type col"
					class:cancel={makePointStatusColumnClass(row.rewardStatus)}>
					{addSignByStatus(row.rewardStatus, String($t(`global.point.rewardStatus.${row.rewardStatus}`)))}
				</div>
				<div class="phone col">{row.userIdentity}</div>
				<div class="items col">{row.summary}</div>
				<div class="amount col">
					{addSignByStatus(row.rewardStatus, row.reward)}P
				</div>
				<div class="createdate col">{processingDate(row.createdDate)}</div>
			</div>
		{/each}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		width: 100%;

		.header {
			display: none;
			padding-bottom: 0px;
			.col {
				font-weight: 200 !important;
				color: #6d6f76 !important;
			}
		}

		.col {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			text-align: center;
			letter-spacing: -0.8px;
		}

		.body {
			display: flex;
			flex-direction: column;

			.row:not(:last-child) {
				border-bottom: 1px solid #e6e7ec;
			}

			.row {
				display: flex;
				padding: 20px 0px;
				flex-wrap: wrap;
				gap: 10px 0px;
				box-sizing: border-box;
			}
		}
		.type {
			font-size: 1.25rem;
			font-weight: 500;
			color: #6591fa;
			order: 1;
			flex-basis: 60px;
			&.cancel {
				color: #e54848;
			}
		}

		.amount {
			flex-basis: calc(100% - 60px);
			font-size: 1.25rem;
			font-weight: 500;
			text-align: right;
			color: #46474b;
			order: 2;
		}

		.items {
			order: 3;
			flex-basis: 100%;
			text-align: left;
		}

		.phone {
			order: 4;
			color: #46474b;
			flex-basis: 50%;
			text-align: left;
		}

		.createdate {
			flex-basis: 50%;
			text-align: right;
			order: 5;
			font-size: 0.875rem;
			color: #6d6f76;
		}
	}

	@include DesktopSize {
		.container {
			.col {
				text-align: center;
			}

			.body {
				.row {
					flex-wrap: nowrap;
					font-size: 1.25rem;
					padding: 19.5px 0px;
					color: #46474b;

					.amount,
					.createdate {
						font-weight: 200;
						color: #46474b;
						font-size: 1.25rem;
					}
				}
			}
			.type {
				flex-basis: 75px;
				min-width: 75px;
				order: 1;
				text-align: center;
			}

			.phone {
				display: flex;
				flex-grow: 260;
				flex-basis: 100%;
				max-width: calc((100% - 75px - 150px) * (260 / 1564));
				min-width: 120px;
				justify-content: center;
				order: 2;
				text-align: center;
			}

			.items {
				flex-grow: 900;
				flex-basis: 100%;
				max-width: calc((100% - 75px - 150px) * (900 / 1564));
				order: 3;
				text-align: center;
			}

			.amount {
				flex-basis: 100%;
				flex-grow: 404;
				max-width: calc((100% - 75px - 150px) * (404 / 1564));
				order: 4;
				text-align: center;
			}

			.createdate {
				order: 5;
				flex-basis: 150px;
				min-width: 150px;
				width: 150px;
				text-align: center;
				font-size: 1rem;
			}
			.header {
				display: flex;
				color: #6d6f76;
				font-size: 1.25rem;
				padding-bottom: 15px;

				.type {
					color: #6d6f76;
					font-size: 1.25rem;
					font-weight: 300;
				}

				.amount {
					font-size: 1.25rem;
					font-weight: 300;
				}
				.createdate {
					font-size: 1.25rem;
				}
			}
		}
	}

</style>
